import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Button from '../elements/Button'
import FormHOC from './FormHOC'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import { SERVICE_WIRELESS } from '../constants'
import ComparePlans from '../components/ComparePlans/ComparePlans'
import CustomLink from '../components/CustomLink'
import InputRow from '../elements/InputRow'
import Addressify from '../elements/Addressify'

const options = {
    postUrl: '/api/postMigrateWireless',
    success: 'Success! Your wireless service has been scheduled for migration.'
}

const state = {
    serviceId: '',
    planId: null,
    planObj: {}, // For GA event
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryAddress: '',
    deliveryCompany: '',
    homeAddress: '',
    termsOfUse: false,
    termsAndConditions: false,
    referrerCode: ''
}

const WirelessMigrationForm = (props) => {
    useEffect(() => {
        props.setDynamicValues({
            serviceId: props.serviceId
        })
    }, [props.serviceId])

    useEffect(() => {
        selectPlanIfSingle()
    }, [props.plans])

    const selectPlanIfSingle = () => {
        if (props.plans.length === 1 && props.plans[0]) {
            props.setDynamicValues({
                planId: props.plans[0].id,
                planObj: props.plans[0]
            })
        }
    }

    const handleChangePlan = (id, planObj) => {
        props.setDynamicValues({
            planId: id,
            planObj: planObj
        })
    }

    const mapExistingPlanFields = () => {
        return {
            title: props.serviceDetails.description,
            data: props.serviceDetails.includedData,
            price: props.serviceDetails.monthlyCharge,
            features: props.serviceDetails.features
        }
    }

    const mapApiPlanFields = () => {
        const plans = []

        props.plans.forEach(plan => {
            plans.push({
                ...plan,
                features: ['No lock-in', 'Maximum speeds 20/20Mbps']
            })
        })

        return plans
    }

    return (
        <div className='wireless-migration-form'>
            {/* {props.plans.length > 0 ? */}
            {[1, 2].length > 0
                ? <React.Fragment>
                    <div className='row'>
                        <div className='col-12 px-lg-4 col-lg-8 offset-lg-2'>
                            <h2 className='text-center'>
                                Choose your migration plan below.<br />You must migrate by 31 July 2022
                            </h2>
                            <ComparePlans
                                type={SERVICE_WIRELESS}
                                plans={mapApiPlanFields()}
                                existingPlan={mapExistingPlanFields()}
                                handleSelect={handleChangePlan}
                                selectedPlanId={parseInt(props.values.planId)}
                            />

                            <div className='row mt-2'>
                                <div className='col-12 text-center mb-3'>
                                    <CustomLink to={props.plans.length > 0 ? props.plans[0].cisLink : ''}><small>Critical information summary</small></CustomLink>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-12 col-lg-8 offset-lg-2'>
                            <div className='bold mb-3 d-inline-block'>Delivery details</div>
                            <div className='delivery-name'>
                                <div>
                                    <p className='font-small sub-bold m-0 mb-1'>First name</p>
                                    <InputRow
                                        name='deliveryFirstName'
                                        value={props.values.deliveryFirstName}
                                        errors={props.errors}
                                        handleChange={props.handleInputChange}
                                        placeholder='First name'
                                        hideLabel
                                    />
                                </div>
                                <div>
                                    <p className='font-small sub-bold m-0 mb-1'>Last name</p>
                                    <InputRow
                                        name='deliveryLastName'
                                        value={props.values.deliveryLastName}
                                        errors={props.errors}
                                        handleChange={props.handleInputChange}
                                        placeholder='Last name'
                                        hideLabel
                                    />
                                </div>
                                <div>
                                    <p className='font-small sub-bold m-0 mb-1'>Company name (if applicable)</p>
                                    <InputRow
                                        name='deliveryCompany'
                                        value={props.values.deliveryCompany}
                                        errors={props.errors}
                                        handleChange={props.handleInputChange}
                                        placeholder='Company name (if applicable)'
                                        hideLabel
                                    />
                                </div>
                            </div>
                            <Addressify
                                label='Home address'
                                name='homeAddress'
                                value={props.values.homeAddress}
                                errors={props.errors}
                                handleSetAddress={props.setDynamicValues}
                                placeholder='Start typing your home address'
                            >
                                <small>So emergency services can find you if you call</small>
                            </Addressify>
                            <Addressify
                                label='Delivery address'
                                name='deliveryAddress'
                                value={props.values.deliveryAddress}
                                errors={props.errors}
                                handleSetAddress={props.setDynamicValues}
                                placeholder='If different from home address above'
                            >
                                <small>We can't deliver to a PO Box</small>
                            </Addressify>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2'>
                            <TermsOfUseCheckbox
                                errors={props.errors}
                                value={props.values.termsOfUse}
                                handleClick={value => props.setDynamicValues({ termsOfUse: value })}
                                cisUrl={props.plans.length > 0 ? props.plans[0].cisLink : ''}
                                termsUrl=''
                            />
                            <br />
                            <TermsAndConditionsCheckbox
                                errors={props.errors}
                                value={props.values.termsAndConditions}
                                handleClick={value => props.setDynamicValues({ termsAndConditions: value })}
                                type={SERVICE_WIRELESS}
                            />
                            <br />
                            {props.children}
                        </div>
                    </div>
                    <div className='row my-4'>
                        <div className='col-12 col-md-4 offset-md-2 text-center text-md-left my-2'>
                            <Button title='Submit Change' action={props.handleSubmit} />
                        </div>
                        <div className='col-12 col-md-4 text-center text-md-right my-2'>
                            <input placeholder='Referrer Code' name='referrerCode' value={props.values.referrerCode} onChange={props.handleInputChange} />
                        </div>
                    </div>
                  </React.Fragment>
                : <p className='bold text-center'>We were unable to find any new plans for you to migrate to. Please call us on 13 39 38.</p>}
        </div>
    )
}

WirelessMigrationForm.propTypes = {
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.object.isRequired
}

export default FormHOC(WirelessMigrationForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/WirelessMigrationForm.js